import { lectio } from '../api';
import ActionTypes from '../constants/ActionTypes';
import { isTopicLoaded } from '../selectors/topic';
import { fetchCategory } from './articles';

export const LETTER_COUNTS_KEY = '__LETTER_COUNTS__';
export const FEATURED_TOPICS_KEY = '__FEATURED_TOPICS__';

export const fetchTopic = (key, page?: number) => {
  return async (dispatch, getState) => {
    const pagedKey = page ? `${key}-${page}` : key;
    if (!key || isTopicLoaded(getState(), pagedKey)) return;

    const { data: topic } = await lectio.get(`/topic/${key}`, { params: { page } });
    if (topic.categoryKey) {
      await dispatch(fetchCategory(topic.categoryKey));
    }
    return dispatch({
      type: ActionTypes.FETCH_TOPIC_SUCCESS,
      payload: { ...topic, key: pagedKey }
    });
  };
};

export const fetchTopicLetterCounts = () => {
  return async (dispatch, getState) => {
    if (isTopicLoaded(getState(), LETTER_COUNTS_KEY)) return;
    const { data: topics } = await lectio.get(`/topics/letters`);
    return dispatch({
      type: ActionTypes.FETCH_TOPIC_SUCCESS,
      payload: { key: LETTER_COUNTS_KEY, topics }
    });
  };
};

export const fetchFeaturedTopics = () => {
  return async (dispatch, getState) => {
    if (isTopicLoaded(getState(), FEATURED_TOPICS_KEY)) return;
    const { data: topics } = await lectio.get(`/topics/featured`);
    return dispatch({
      type: ActionTypes.FETCH_TOPIC_SUCCESS,
      payload: { key: FEATURED_TOPICS_KEY, topics }
    });
  };
};

export const fetchTopicsByLetter = letter => {
  const key = `__LETTER__${letter}`.toUpperCase();
  return async (dispatch, getState) => {
    if (isTopicLoaded(getState(), key)) return;
    const { data: topics } = await lectio.get(`/topics/letter/${letter}`);
    return dispatch({
      type: ActionTypes.FETCH_TOPIC_SUCCESS,
      payload: { key, topics }
    });
  };
};
